import React, { Component } from "react";
import Modal from "react-bootstrap/Modal";
import { withRouter } from "react-router-dom";
import { Button, Card, Form, Input } from "antd";
import { UserOutlined } from "@ant-design/icons";
import FormLoader from "swfrontend/MDM/MDMScreens/FormView/FormLoader";
import AndtDPasswordBoxWrapper from "swfrontend/MDM/MDMAntdWrappers/PasswordBoxWrapper";
import { openNotification } from "swfrontend/COMS/NotificationMessageMapping";
import { openNotificationType } from "swfrontend/MDM/MDMUIConfigs/MDMUIMappings";
import { localStorageVariableName } from "swfrontend/AppConfigs";
import AuthDataProvider from "../../AuthDataProvider";
import { URLS } from "../../constants";
import "../../LoginPage.css";
import { NOTIFICATIONS } from "../../../LandingPage/constants";
import { ErrorLogger } from "../../../App/Utils/ErrorHandler";

class LoginPageContent extends Component {
  formRef = React.createRef();
  DataProvider = new AuthDataProvider();

  state = {
    isLoading: false,
  };

  componentDidMount() {
    if (localStorage.getItem(localStorageVariableName.isLoggedIn) != null) {
      this.props.history.push({
        pathname: URLS.UPDATE_REGISTRATION,
      });
      window.location.href = URLS.UPDATE_REGISTRATION;
    }
  }

  onFinish = (values) => {
    this.login(values);
  };

  login = (values) => {
    try {
      Object.keys(values).forEach((each) => {
        values[each] = window.btoa(values[each].trim())
      });

      this.setState({ isLoading: true });
      this.DataProvider.post_api_call(`${URLS.LOGIN}`, values)
        .then((res) => {
          if (res.ok) {
            res.json().then((res) => {
              localStorage.setItem(
                localStorageVariableName.userName,
                res["username"]
              );

              // OTP VERIFICATION FOR EVERY LOGIN
              if (res.is_staff === false) {
                this.props.history.push(URLS.RESET_USERNAME_URL, {
                  step: res.last_login === null ? undefined : 2
                });
                return;
              }

              // IF NOT FIRST LOGIN THEN SAVE TOKEN, IS_STAFF
              if(process.env.NODE_ENV === "development"){
                localStorage.setItem(
                  localStorageVariableName.authToken,
                  JSON.stringify("Token " + res["Your Token"])
                );
              }
              localStorage.setItem("is_staff", res.is_staff);
              localStorage.setItem(localStorageVariableName.isLoggedIn, true);

              // window.location.href = URLS.PORTAL_URL;
              window.onbeforeunload = null;
              window.location.reload();
            });
          } else if (res.status === 429) {
            openNotification(
              openNotificationType.warning,
              NOTIFICATIONS.SUSPICIOUS,
              NOTIFICATIONS.TO_MANY_LOGIN
            );
          } else {
            return res.json().then((res) => {
              Object.keys(res).map((error) => {
                openNotification(openNotificationType.error, error, res[error]);
              });
            });
          }
        })
        .finally(() => this.setState({ isLoading: false }));
    } catch (error) {
      ErrorLogger(error.toString());
      openNotification(
        openNotificationType.error,
        NOTIFICATIONS.ERROR_OCCURED,
        NOTIFICATIONS.REFRESH_PAGE
      );
    }
  };

  onForgetPassword = () => {
    this.props.history.push(URLS.FORGET_PASSWORD_URL);
  };

  render() {
    return (
      <>
        <Modal show={this.state.isLoading} centered>
          <Modal.Body>
            <FormLoader loading="true" />
          </Modal.Body>
        </Modal>

        <Form
          onFinish={this.onFinish}
          layout="vertical"
          ref={this.formRef}
          className="container_bg text-center"
          autoComplete="off"
        >
          <Card title="Login in Customer Portal" className="main_card p-1">
            <div className="col-lg-12 col-md-12">
              <Form.Item
                name="username"
                label="Username"
                validateTrigger="onBlur"
                rules={[
                  {
                    required: true,
                    message: "Enter Username",
                  },
                ]}
              >
                <Input
                  placeholder="Username"
                  suffix={<UserOutlined className="user-icon" />}
                  autoComplete="off"
                />
              </Form.Item>
            </div>

            <div className="col-lg-12 col-md-12">
              <AndtDPasswordBoxWrapper
                decorator="password"
                id="Password"
                required="true"
                label="Password"
                message="Enter Password"
                placeholder="Enter Password"
                validators=""
                formRef={this.formRef}
                autoComplete="off"
              />
            </div>

            <div className="col-lg-12 col-md-12 text-right">
              <Button
                type="link"
                onClick={this.onForgetPassword}
                id="forgetpassword"
              >
                <b>Forget Password ?</b>
              </Button>
            </div>

            <div className="col-lg-12 col-md-12 text-center">
              <Button htmlType="submit" type="primary" id="login">
                Login
              </Button>
            </div>
          </Card>
        </Form>
        <br />
        <br />
        <br />
      </>
    );
  }
}

export default withRouter(LoginPageContent);
